import React, { useEffect, useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';
import { ArrowLeftIcon } from '../../../components/Icon';
import Text from '../../../components/Text';
import PatientInfoCard from '../PatientInfoCard';
import rou from '../../../router';
import { patientSurveyAPI } from '../../../apis';
import ShareSurveyPopup from '../Popups/ShareSurveyPopup';
import SenderContactPopup from '../Popups/SenderContactPopup';
import { useQuery } from '../../../utils/useQuery';
import { alertMsg } from '../../../apis/commlogic';

const useStyles = makeStyles(() => ({
  backIcon: {
    fontSize: '1.5rem',
    color: '#538fff',
  },
}));

const PatientSurveyDetail = () => {
  const classes = useStyles();
  const history = useHistory();
  const [patientData, setPatientData] = useState();
  const [senderContactPopup, setSenderContactPopup] = useState({ open: false, responseDetailId: null });
  const [shareSurveyPopup, setShareSurveyPopup] = useState({ open: false, responseId: null });
  const query = useQuery();
  const rouList = useSelector((state) => state.rouList);

  const handleBack = () => {
    history.push(rou.patientSurveyRou.path);
  };

  const getPatientSurveyDetail = async () => {
    try {
      const params = {
        responseId: query.responseId,
      };
      const { result } = await patientSurveyAPI.getPatientSurveyDetail(params);
      setPatientData(result);
    } catch (error) {
      console.log('error', error);
      if (error.statusCode === '2205') {
        history.push(rou.patientSurveyRou.path);
      }
    }
  };

  useEffect(() => {
    getPatientSurveyDetail();
  }, [rouList]);

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        bgcolor="#FFFFFF"
        boxShadow="0px 1px 0px 0px #E4E7EB"
        height="4.375rem"
        pl="2.62rem"
      >
        <ButtonBase onClick={handleBack}>
          <ArrowLeftIcon className={classes.backIcon} />
          <Text fontSize="1rem" color="#538FFF" ml="0.5rem">
            Back
          </Text>
        </ButtonBase>
      </Box>
      <Box p="1.87rem 3.44rem">
        <PatientInfoCard
          data={patientData}
          setSenderContactPopup={setSenderContactPopup}
          setShareSurveyPopup={setShareSurveyPopup}
        />
      </Box>
      {senderContactPopup.open && (
        <SenderContactPopup
          handleClose={() => setSenderContactPopup({ open: false, responseDetailId: null })}
          responseDetailId={senderContactPopup?.responseDetailId}
        />
      )}
      {shareSurveyPopup.open && (
        <ShareSurveyPopup
          handleClose={() => setShareSurveyPopup({ open: false, responseId: null })}
          responseId={shareSurveyPopup?.responseId}
          handleConfirm={getPatientSurveyDetail}
        />
      )}
    </Box>
  );
};

export default PatientSurveyDetail;
